module.exports = __webpack_public_path__ + "static/media/logo.e651a0a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 298
// module chunks = 0